namespace $.$$ {
	export class $shm_hitalama_map_head extends $.$shm_hitalama_map_head {

		team( next?: $shm_hitalama_team | null ) {
			if( next !== undefined ) return next
			return this.$.$shm_hitalama_app.Root( 0 ).team_current()
		}

		title( next?: string ) {
			const map = this.map()
			if( !map.can_read() ) return 'Доступ к карте закрыт'
			if( next !== undefined && !map.can_change() ) return map.title()
			const title = map.title( next )
			this.$.$shm_hitalama_map_loading.current( map.link().str )?.name( title )
			if( next !== undefined ) map.summary_publish()
			return title
		}
		
		sub() {
			this.guest_arg_auto()
			const sub = super.sub()
			return this.editor_mode_enabled()
				? sub.filter( item => ![
					this.Widget_list_visible(),
					this.Rights_visible(),
					this.Drawing_tools_visible(),
					this.Interaction_locked(),
				].includes( item as $mol_check_icon ) )
				: sub
		}

		@ $mol_mem
		map_id() {
			return this.map().link().toString()
		}

		edit_widget_arg() {
			return this.$.$mol_state_arg.value( 'edit_widget' )
		}

		guest_token() {
			return 'sUzvXKHzYYgbCHS'
		}

		map_public() {
			return [ 'public_read', 'public_edit' ].includes( this.map().access_level() )
		}

		guest_arg_auto() {
			if( !this.map().can_read() ) return
			const guest = this.$.$mol_state_arg.value( 'guest' )
			if( this.map_public() ) {
				if( !guest ) this.$.$mol_state_arg.value( 'guest', this.guest_token() )
			} else if( guest ) {
				this.$.$mol_state_arg.value( 'guest', null )
			}
		}

		widget_list_visible( next?: boolean ) {
			return this.Settings_content().widget_list_visible( next )
		}

		rights_visible( next?: boolean ) {
			return this.Settings_content().rights_visible( next )
		}

		@ $mol_mem
		drawing_tools_visible( next?: boolean ) {
			const visible = this.$.$mol_state_local.value( this.toString() + '.drawing_tools_visible', next ) ?? true
			return visible && !this.interaction_locked()
		}


		widget_props_visible( next?: boolean ) {
			return this.Settings_content().widget_props_visible( next )
		}

		widget_headers_visible( next?: boolean ) {
			return this.Settings_content().widget_headers_visible( next )
		}

		arrows_visible( next?: boolean ) {
			return this.Settings_content().arrows_visible( next )
		}

		editor_mode_enabled( next?: boolean ) {
			return this.Settings_content().editor_mode_enabled( next )
		}

		open_in_new_uri() {
			const dict = this.$.$mol_state_arg.dict()
			const section = this.$.$mol_state_arg.value( 'section' )
			const uri = section === 'map'
				? this.$.$mol_state_arg.link({ ...dict, section: 'maps' })
				: this.$.$mol_state_arg.link({ ...dict, section: 'map' })
			return uri
		}

		@ $mol_action
		open_in_new_click( event?: MouseEvent ) {
			const invoke = ( this.$.$mol_dom_context.window as any ).__TAURI__?.core?.invoke as
				| ( ( command: string, args?: Record< string, unknown > )=> Promise< unknown > )
				| undefined
			if( !invoke ) return null

			event?.preventDefault()
			const url = new URL( this.open_in_new_uri(), this.$.$mol_dom_context.location.href ).toString()
			invoke( 'open_external', { url } ).catch( $mol_fail_log )
			return null
		}
		
	}
}
